import React, { createContext, useContext, useMemo, useState } from "react";

// Identity of the aspirant currently resolved on the public /submission pages,
// shared with the layout's Header. It does NOT go through Redux userSlice: this
// is an unauthenticated session (nuip resolved by OTP or magic link), not a
// Firebase Auth user, and the two must not be confused by anything reading
// state.user.value.
//
// Identity shape: { fullName, photoUrl, onLogout }.

const ApplicantSessionContext = createContext(null);

export function ApplicantSessionProvider({ children }) {
  const [identity, setIdentity] = useState(null);
  const value = useMemo(() => ({ identity, setIdentity }), [identity]);
  return (
    <ApplicantSessionContext.Provider value={value}>
      {children}
    </ApplicantSessionContext.Provider>
  );
}

// Returns null outside the provider, so the Header can call it anywhere.
export function useApplicantSession() {
  return useContext(ApplicantSessionContext);
}
